import { addToGlobalThisRet, htmlToElement } from "@plugins";

export class ItcCustomSelect {
    constructor(target, options) {
        this.element = typeof target === "string" ? document.querySelector(target) : target;
        this.target = this.element.querySelector("[data-select=target]");

        this._setDefaults(options);
        this._init();
        this._hideTargetSelect();
    }

    static hideOpenSelect() {
        document.addEventListener("click", (e) => {
            if (!e.target.closest("[data-select=toggle]")) {
                const elsActive = document.querySelectorAll(".custom-select__show");

                elsActive.forEach((el) => {
                    el.classList.remove("custom-select__show");
                });
            }
        });
    }

    _setDefaults(options) {
        const defaults = {
            template(selectOptions) {
                return `
                    <div class="custom-select__wrap">
                        <button
                            type="button"
                            class="custom-select__toggle"
                            data-select="toggle"
                        >${selectOptions.selectedContent}</button>
                        <div class="custom-select__dropdown">
                            <div class="custom-select__options">${selectOptions.items}</div>
                        </div>
                    </div>`;
            },
        };
        Object.assign(this, defaults, options);
    }

    _init() {
        if (!this.element.querySelector(".custom-select__wrap")) {
            this._createCustomSelect();
            this.listener = this._initListeners.bind(this);
            this.element.addEventListener("click", this.listener);
        } else {
            this.element.querySelector(".custom-select__wrap").remove();
            this._createCustomSelect();
        }
    }

    _hideTargetSelect() {
        this.target.style.display = "none";
    }

    _createCustomSelect() {
        const options = this._createDropdown();

        this.customSelect = htmlToElement(
            this.template({
                selectedContent: options.selectedContent ? options.selectedContent : "",
                items: options.dropdownOptions.join(''),
            }),
        );

        this.target.after(this.customSelect);
    }

    _createDropdown() {
        const options  = {};
        const dropdownOptions = [];

        for (let i = 0; i < this.target.options.length; i++) {
            const option = this.target.options[i];

            if (option.selected) {
                options.selectedValue = option.value;
                options.selectedIndex = option.index;
                options.selectedContent = option.text;
            }

            if (option.hasAttribute("data-placeholder")) {
                options.selectedContent = option.dataset.placeholder;

                continue;
            }

            dropdownOptions.push(`
                <div
                    class="custom-select__option${option.selected ? " custom-select__option--selected" : ""}"
                    data-value="${option.value}"
                    data-index="${option.index}"
                    data-select="option"
                >${option.text}</div>`
            );
        }

        options.dropdownOptions = dropdownOptions;

        return options;
    }

    _initListeners(e) {
        const type = e.target.closest("[data-select]").dataset.select;

        if (type === "toggle") {
            this._toggle();
        } else if (type === "option") {
            this._changeValue(e.target);
        }
    }

    _toggle() {
        this.element.classList.contains("custom-select__show") ? this._close() : this._show();
    }

    _show() {
        document.querySelectorAll(".custom-select__show").forEach((el) => {
            el.classList.remove("custom-select__show");
        });
        this.element.classList.add("custom-select__show");
    }

    _close() {
        this.element.classList.remove("custom-select__show");
    }

    _changeValue(elem) {
        this._updateTogglerValue(elem);
        this._updateOptionsList(elem);
        this._dispatchEvent(elem.dataset.value);
        this._close();
    }

    _updateTogglerValue(elem) {
        const toggler = this.element.querySelector("[data-select=toggle]");

        toggler.textContent = elem.textContent;
        toggler.classList.add("picked");
    }

    _updateOptionsList(target) {
        const selectedOption = this.element.querySelector(".custom-select__option--selected");

        if (selectedOption) {
            selectedOption.classList.remove("custom-select__option--selected");
        }

        target.classList.add("custom-select__option--selected");
    }

    _dispatchEvent(value) {
        this.target.value = value;
        this.target.dispatchEvent(new CustomEvent("change", { bubbles: true, }));
    }
}

function initCustomSelects(target) {
    if (target) {
        new ItcCustomSelect(target);
    } else {
        const selects = [...document.querySelectorAll("[data-custom-select]")];

        if (selects.length > 0) {
            for (const select of selects) {
                new ItcCustomSelect(select);
            };

            ItcCustomSelect.hideOpenSelect();
        }
    }
}

window.addEventListener("load", () => initCustomSelects());

addToGlobalThisRet(initCustomSelects, "initCustomSelects");
